import { Image, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';

type LocationHeroProps = {
	img?: ImageField;
};

const LocationHero = (props: LocationHeroProps): JSX.Element => {
	return (
		<div className="overhauled">
			<div className="location-hero">
				<div className="top-section">
					<div className="location-img-outer">
						{props.img?.value?.src ? (
							<div className="location-image">
								<Image field={props.img} alt="Location Image" />
							</div>
						) : (
							<Image src="/assets/images/profile-bg.png" alt="Default Background" />
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default LocationHero;
